import { PRIMARY_COLOR } from '../../config/color';

export const HomePageArrow = (props: { class?: string }) => (
  <svg class={props.class} viewBox="0 0 22 23" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M19.25 11.5H2.75" stroke="currentColor" stroke-width="1.375" />
    <path d="M13.75 6L19.25 11.5L13.75 17" stroke="currentColor" stroke-width="1.375" />
  </svg>
);

export const HomePageImgLeftTopTriangleMark = () => (
  <svg viewBox="0 0 94 94" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M94 0H0V94L94 0Z" fill="#3309CD" />
  </svg>
);

export const HomePageCardArrow = () => (
  <svg viewBox="0 0 60 36" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M44.0769 1.45519L43.0163 0.394531L40.8949 2.51585L41.9556 3.57651L54.8788 16.4997L2.37109 16.4997H0.871094V19.4997H2.37109L54.8788 19.4997L41.9556 32.4229L40.8949 33.4836L43.0163 35.6049L44.0769 34.5443L59.5608 19.0604C60.1466 18.4746 60.1466 17.5248 59.5608 16.9391L44.0769 1.45519Z"
      fill="currentColor"
    />
  </svg>
);

export const HomePageDTIcon = () => (
  <svg viewBox="0 0 30 31" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M14.9999 15.3945V7.89453M14.9999 15.3945L8.4375 19.1833M14.9999 15.3945L21.5624 19.1833"
      stroke="#262626"
      stroke-width="1.875"
    />
    <path
      d="M8.75 10.3945C8.75 11.7752 7.63069 12.8945 6.25 12.8945C4.86929 12.8945 3.75 11.7752 3.75 10.3945C3.75 9.01384 4.86929 7.89453 6.25 7.89453C7.63069 7.89453 8.75 9.01384 8.75 10.3945Z"
      fill="#262626"
      stroke="#262626"
      stroke-width="1.875"
    />
    <path
      d="M8.75 20.3945C8.75 21.7752 7.63069 22.8945 6.25 22.8945C4.86929 22.8945 3.75 21.7752 3.75 20.3945C3.75 19.0138 4.86929 17.8945 6.25 17.8945C7.63069 17.8945 8.75 19.0138 8.75 20.3945Z"
      fill="#262626"
      stroke="#262626"
      stroke-width="1.875"
    />
    <path
      d="M17.5 25.3945C17.5 26.7752 16.3807 27.8945 15 27.8945C13.6193 27.8945 12.5 26.7752 12.5 25.3945C12.5 24.0138 13.6193 22.8945 15 22.8945C16.3807 22.8945 17.5 24.0138 17.5 25.3945Z"
      fill="#262626"
      stroke="#262626"
      stroke-width="1.875"
    />
    <path
      d="M26.25 20.3945C26.25 21.7752 25.1307 22.8945 23.75 22.8945C22.3693 22.8945 21.25 21.7752 21.25 20.3945C21.25 19.0138 22.3693 17.8945 23.75 17.8945C25.1307 17.8945 26.25 19.0138 26.25 20.3945Z"
      fill="#262626"
      stroke="#262626"
      stroke-width="1.875"
    />
    <path
      d="M26.25 10.3945C26.25 11.7752 25.1307 12.8945 23.75 12.8945C22.3693 12.8945 21.25 11.7752 21.25 10.3945C21.25 9.01384 22.3693 7.89453 23.75 7.89453C25.1307 7.89453 26.25 9.01384 26.25 10.3945Z"
      fill="#262626"
      stroke="#262626"
      stroke-width="1.875"
    />
    <path
      d="M17.5 5.39453C17.5 6.77522 16.3807 7.89453 15 7.89453C13.6193 7.89453 12.5 6.77522 12.5 5.39453C12.5 4.01382 13.6193 2.89453 15 2.89453C16.3807 2.89453 17.5 4.01382 17.5 5.39453Z"
      fill="#262626"
      stroke="#262626"
      stroke-width="1.875"
    />
  </svg>
);

export const HomePageAIIcon = () => (
  <svg viewBox="0 0 30 31" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M4.13044 12.1C4.13044 7.0625 8.7299 3 14.4116 3C17.2794 3 19.8227 4.02916 21.7165 5.65411C22.8528 6.52087 23.827 7.65832 24.3139 9.06661C24.6385 9.87916 24.9092 11.0167 24.9092 11.8834C24.9092 12.9667 24.368 14.1042 24.8551 15.1333C25.1798 15.8917 26.0455 16.5417 26.5866 17.1376C26.5866 17.1376 28.1558 18.1667 25.1798 18.3292C25.0715 18.3292 24.6927 20.1166 24.6385 20.4959C24.6927 20.5501 24.7468 20.6584 24.7468 20.8208C24.7468 21.1459 24.3139 21.4167 23.7728 21.4167H23.4481C24.1516 21.525 24.6385 21.7959 24.6385 22.175C24.6385 22.4459 24.3139 22.7709 23.827 22.9876C23.827 22.9876 24.4222 24.9375 23.5563 25.3709C23.3941 25.425 23.1776 25.4792 22.9611 25.425C21.6625 25.4792 19.3897 25.425 18.0912 25.425L17.4418 29H5.91614L7.05244 20.7124C4.99616 17.7876 4.29268 15.1875 4.29268 13.0209C4.13044 12.75 4.13044 12.4251 4.13044 12.1ZM10.1859 10.5391C10.9973 10.5391 11.7547 10.0505 12.0792 9.34471L13.6478 10.2677C13.4315 10.702 13.3233 11.1363 13.3233 11.6249C13.3233 12.2765 13.5397 12.8737 13.8643 13.3623L10.9432 15.0453C10.7809 14.8826 10.5105 14.7196 10.24 14.7196C9.64498 14.7196 9.21227 15.2082 9.21227 15.7511C9.21227 16.3483 9.69908 16.7826 10.24 16.7826C10.835 16.7826 11.2678 16.294 11.2678 15.7511C11.2678 15.6425 11.2138 15.5339 11.2138 15.4797L14.2429 13.7424C14.8379 14.3396 15.5952 14.7196 16.5148 14.7196C18.2457 14.7196 19.6522 13.308 19.6522 11.5707C19.6522 9.83333 18.2457 8.42184 16.5148 8.42184C15.4329 8.42184 14.5134 8.96474 13.9725 9.77904L12.2956 8.80183C12.2956 8.69321 12.3497 8.53031 12.3497 8.42184C12.3497 7.28172 11.4301 6.30436 10.24 6.30436C9.10406 6.30436 8.13043 7.22741 8.13043 8.42184C8.13043 9.61614 9.04997 10.5392 10.1859 10.5392V10.5391Z"
      fill="#262626"
    />
  </svg>
);

export const HomePageDAIcon = () => (
  <svg viewBox="0 0 30 31" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M14.996 15.0624C18.1631 15.0624 20.7323 12.4911 20.7323 9.32613C20.7323 6.1597 18.1631 3.58984 14.996 3.58984C11.8296 3.58984 9.25972 6.1597 9.25972 9.32613C9.25972 12.4911 11.8296 15.0624 14.996 15.0624ZM16.43 17.9305C10.6938 17.9305 3.52344 19.845 3.52344 23.6668V27.969H26.4685V23.6668C26.4685 19.845 20.2547 17.9305 16.43 17.9305Z"
      fill="#262626"
    />
  </svg>
);

export const EmailSvg = () => (
  <svg viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M1.5 14.625H16.5V9V3.375H9H1.5V9V14.625Z" stroke="currentColor" stroke-width="1.13" />
    <path
      d="M2 4.00022L9 9.5L16 3.875"
      stroke="currentColor"
      stroke-width="1.13"
      stroke-linecap="square"
    />
    <path d="M9 3.375H1.5V9" stroke="currentColor" stroke-width="0.75" stroke-linecap="square" />
    <path d="M16.5 9V3.375H9" stroke="currentColor" stroke-width="0.75" stroke-linecap="square" />
  </svg>
);

export const SearchArrow = () => (
  <svg viewBox="0 0 35 36" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M30.625 18H4.375" stroke="#262626" stroke-width="2" />
    <path d="M21.875 9.25L30.625 18L21.875 26.75" stroke="#262626" stroke-width="2" />
  </svg>
);
export const SearchDel = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="14" height="15" viewBox="0 0 14 15" fill="none">
    <path
      d="M2.33594 2.83398L11.6693 12.1673"
      stroke="#9E9E9E"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M2.33594 12.1673L11.6693 2.83398"
      stroke="#9E9E9E"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);
export const HotWorld = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="19" viewBox="0 0 18 19" fill="none">
    <path
      d="M9 17.4707C12.088 17.4707 14.6249 15.0235 14.6249 11.8825C14.6249 11.1114 14.5857 10.2848 14.1583 9.00005C13.7309 7.71538 13.6448 7.54955 13.1928 6.75617C12.9998 8.37523 11.9666 9.05 11.7042 9.25168C11.7042 9.04187 11.0792 6.72167 10.1316 5.33342C9.20137 3.9707 7.93628 3.07667 7.19449 2.4707C7.19449 3.62187 6.87071 5.33342 6.40702 6.20548C5.94334 7.07754 5.85626 7.1093 5.27707 7.75828C4.69792 8.40725 4.43209 8.60769 3.94778 9.39512C3.46349 10.1826 3.375 11.2314 3.375 12.0025C3.375 15.1435 5.91199 17.4707 9 17.4707Z"
      fill="#FF8301"
      stroke="#FF8301"
      stroke-linejoin="round"
    />
  </svg>
);

export const CarouselArrow = () => (
  <svg viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g opacity="0.8">
      <path
        d="M39.583 25L64.583 50L39.583 75"
        stroke="white"
        stroke-width="4"
        stroke-linecap="square"
      />
    </g>
  </svg>
);

export const TourStepsArrow = () => (
  <svg viewBox="0 0 108 109" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M54.0003 51.4219L27.0003 24.4219L24.1719 27.2503L54.0003 57.0787L83.8287 27.2503L81.0003 24.4219L54.0003 51.4219ZM54.0003 78.4219L27.0003 51.4219L24.1719 54.2503L54.0003 84.0787L83.8287 54.2503L81.0003 51.4219L54.0003 78.4219Z"
      fill="url(#paint0_linear_5045_20623)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_5045_20623"
        x1="54"
        y1="38"
        x2="54.0003"
        y2="81.2503"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="white" />
        <stop offset="1" stop-color="white" stop-opacity="0.2" />
      </linearGradient>
    </defs>
  </svg>
);

export const WhitePageAngle = () => (
  <svg viewBox="0 0 76 76" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g filter="url(#filter0_f_5093_20778)">
      <path d="M9 9H14.9706L66.9997 61.4148V67H9V9Z" fill="#2D2D2D" fill-opacity="0.06" />
    </g>
    <path d="M14.9688 9L66.9979 61.4148H14.9688V9Z" fill="currentColor" />
    <defs>
      <filter
        id="filter0_f_5093_20778"
        x="0.6"
        y="0.6"
        width="74.8"
        height="74.8"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feGaussianBlur stdDeviation="4.2" result="effect1_foregroundBlur_5093_20778" />
      </filter>
    </defs>
  </svg>
);

export const BluePageAngle = () => (
  <svg height="85" viewBox="0 0 85 85" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M0 0L85 85H0V0Z" fill="#DEE9F9" />
  </svg>
);

export const TourStepsLeftBottomBlock = () => (
  <svg viewBox="0 0 90 90" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M0 45V90H45L0 45Z" fill={PRIMARY_COLOR} fill-opacity="0.1" />
    <path d="M45 45V90H90L45 45Z" fill={PRIMARY_COLOR} fill-opacity="0.1" />
    <path d="M0 0V45H45L0 0Z" fill={PRIMARY_COLOR} fill-opacity="0.1" />
  </svg>
);

export const TourStepSealCover = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 660 179" fill="none">
    <path d="M0 0L330 67.125L660 0V179H330H0V0Z" fill="url(#paint0_linear_5156_6207)" />
    <defs>
      <linearGradient
        id="paint0_linear_5156_6207"
        x1="807.321"
        y1="205.85"
        x2="-195.779"
        y2="-428.076"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#E2EFFF" />
        <stop offset="0.550589" stop-color="#E5E7FF" />
        <stop offset="1" stop-color="#FFDEEB" />
      </linearGradient>
    </defs>
  </svg>
);

export const Exit = () => (
  <svg viewBox="0 0 28 29" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M13.9952 4H3.5V25H14" stroke="white" stroke-width="2.5" stroke-linecap="square" />
    <path
      d="M20.2227 19.75L25.4727 14.5L20.2227 9.25"
      stroke="white"
      stroke-width="2.5"
      stroke-linecap="square"
    />
    <path d="M9.33203 14.4951H24.4987" stroke="white" stroke-width="2.5" stroke-linecap="square" />
  </svg>
);
